export default function PHP_ob_get_level() {
  return (
    <div>
      <h1>PHP_ob_get_level</h1>
    </div>
  );
}
